import { useTranslation } from 'react-i18next';
import { Button } from 'src/components/Buttons/Button';
import { IModalContent } from 'src/pages/Game/hooks/useGameModals';
import { ModalWrapper } from 'src/components/ModalWrapper';
import { useModalContext } from 'src/hooks/useModalContext';

type ModalProps = {
  messages: IModalContent[];
  onClose: () => void;
};

export const GameNotificationModal = () => {
  const { t } = useTranslation();
  const { modalProps, closeModal } = useModalContext<ModalProps>();

  return (
    <ModalWrapper>
      <div className="flex flex-col items-center gap-[20px] p-7 w-[340px]">
        {modalProps?.messages?.map((item, index) => {
          return (
            <div key={index} className="mb-[10px]">
              <p className="font-bold text-base w-full text-center text-gnm_text">{item.content}</p>
              {item.haveAdditionalContent && (
                <p className="text-2xl font-bold text-gnm_text w-full text-center">
                  {item.additionalContent}
                </p>
              )}
            </div>
          );
        })}
        <Button
          mode="button-secondary"
          className="max-w-[150px]"
          onClick={() => {
            modalProps?.onClose?.();
            closeModal();
          }}
          title={`${t('gameNotification.close')}`}>
          {t('gameNotification.close')}
        </Button>
      </div>
    </ModalWrapper>
  );
};

export default GameNotificationModal;
